export default __webpack_public_path__ + "static/cooling_towers_w.0c06e44fbdbea4456ee465822481f99a.png";